module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAJ1BMVEUAAAD///////////////////////////////////////////////+uPUo5AAAADHRSTlMA3yCA7zBgkL9vUECronOEAAAAQUlEQVQoz2MYXEAcXaDHAE1A8TCaAJNMAppIiCuaAPcRBTSRHCE0AeaDhATmoGnhQjc05CiGwwg4XcYAw/uDDQAA748KPgIisksAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiantou_wap.png
// module id = +83W
// module chunks = 12